/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowCRightIcon16Regular = forwardRef('ArrowCRightIcon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M5.466 2.973a.75.75 0 0 1 1.06-.007L10.37 6.76a1.75 1.75 0 0 1 .008 2.483L6.59 13.03a.75.75 0 0 1-1.06-1.06L9.316 8.18a.25.25 0 0 0-.002-.354L5.473 4.034a.75.75 0 0 1-.007-1.06Z" })));
});
